<template>
  <!-- 头部整体盒子 -->
  <div id="header"  :class="fixedTop || isSearch ? 'fixed-top container-fuild' : 'container-fuild'">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs" :class="{'en':selectvalue === 'EN'}">
      <!-- 导航logo -->
      <div class="header-nav-logo" @click="routerPush('/home')" :class="{'en':selectvalue === 'EN'}">
        <img :src="logoimg">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)">
          <!-- <router-link :to="item.path"> -->
              <!-- <router-link :to="{  path: selectvalue +item.path}"> -->
          <router-link :to="'/' + selectvalue.toLowerCase() + item.path">
            <!-- <template @click="routerPush()"> -->
            {{ $t(`header.${item.name}`) }}
            <!-- {{ item.name }} -->
            <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
            <!-- </template> -->
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>

      <div class="language-select" :class="{ 'EN': selectvalue === 'EN' }" @click="showlangueBox" @mouseleave="isShowLangueBox=false">
        <!-- <select id="languageSelect" v-model="selectvalue">
          <option value="EN">English</option>
          <option value="CN">中文</option>
        </select> -->
        <div class="languageSelected" v-clickoutside="outsideClose">{{ selectvalue=='EN' ?'EN' : '中文' }}
          <img v-if="fixedTop" src="@/assets/img/down2.png"/>
          <img v-else src="@/assets/img/down_white.png"/>
        </div>
        <div class="languageSelect-box" :style="{'display':isShowLangueBox?'block':'none'}" >
          <a :href="'/en' + currentPathWithoutLang" @click.prevent="switchLanguage('en')" class="languageSelect-item" :class="{ 'active': selectvalue === 'EN' }">EN - English</a>
          <a :href="'/cn' + currentPathWithoutLang" @click.prevent="switchLanguage('cn')" class="languageSelect-item" :class="{ 'active': selectvalue !== 'EN' }">CN - 中文简体</a>
        </div>
      </div>
      <div class="longstring" :class="{'active':fixedTop}"> </div>
      <div class="search" @click="searchEvent" @mouseenter="mouseenter" @mouseleave="searchimg = ''">
        <img
          :src="searchimg ? searchimg : fixedTop || isSearch ? require('@/assets/img/search-gray.png') : require('@/assets/img/search.png')" />
      </div>
      <!-- 搜索框 -->
      <!-- <div class="searchinput" v-if="isShowSearchinput"> -->
      <!-- <my-select v-model="currentSearchValue" :loading="loading" filterable remote :remote-method="remoteMethod"
          :remote-data-list="options2" :maxHeight="200" @on-change="handleChange">
          <my-option v-for="item in options2" :key="item.value" :value="item.value" :label="item.label"></my-option>
        </my-select> -->
      <!-- </div> -->

    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <!-- <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo_black.png" alt="logo">
      </div> -->
      <!-- 导航栏 -->
      <!-- <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
          <span :class="menuClass"></span>
        </div>
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)" data-toggle="collapse" data-target="#menu">
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>


<script>
import MySelect from "./mySelect/MySelect.vue"
import MyOption from "./mySelect/MyOption.vue"

export default {
  name: "Header",
  data () {
    return {
      isShowSearchinput: false,
      selectvalue: localStorage.getItem('lang') || 'CN',
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "home",
          path: "/home",
          children: []
        },
        {
          name: "aboutkl",
          path: "/AboutKangLin",
          children: []
        },
        {
          name: "product",
          path: "/Production",
          children: []
        },
        {
          name: "patientZone",
          path: "/prefecture",
          children: []
        },
        {
          name: "news",
          path: "/news",
          children: []
        },
        {
          name: "enterprise",
          path: "/Enterprise",
          children: []
        },
        {
          name: "expansion",
          // path: "/contactus",
          path: "/teamwork",
          children: []
        }
      ],
      options2: [],
      currentSearchValue: "",
      loading: false,
      states: [
        "Alabama",
        "Alaska",
      ],
      fixedTop: false,
      isSearch: false,
      logoimg: require('@/assets/img/logo_w.png'),
      searchimg: '',
      isShowLangueBox:false
    };
  },
  components: { MySelect, MyOption },
  computed: {
    currentPathWithoutLang() {
      return this.$route.path.replace(/^\/(en|cn)/, '') || '/home'
    }
  },
  methods: {
    switchLanguage(lang) {
      localStorage.setItem('lang', lang.toUpperCase())
      this.selectvalue = lang.toUpperCase()
      this.$router.push('/' + lang + this.currentPathWithoutLang)
      this.$emit('selectvalue', this.selectvalue);
    },
    routerPush(path){
      sessionStorage.setItem('navIndex', '0')
      let lang = (localStorage.getItem('lang') || 'EN').toLowerCase()
      let url = '/' + lang + path
      this.$router.push({
        path:url
      })
    },
    searchEvent () {
      this.isShowSearchinput = !this.isShowSearchinput
      let lang = (localStorage.getItem('lang') || 'EN').toLowerCase()
      this.$router.push({
        path: '/' + lang + '/search'
      })
    },
    navClick (index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index)
      this.menuName = name;
    },
    mouseenter () {
      this.searchimg = require('@/assets/img/search-active.png')
    },
    menuClick () {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    handleChange (value) {
    },
    // 远程搜索
    remoteMethod (query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options2 = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options2 = [];
      }
    },
    fixedTopinit () {
      let _this = this
      window.onscroll = function (e) {
        var scrollT = document.documentElement.scrollTop;
        _this.fixedTop = scrollT > 75

        _this.logoimg = scrollT > 75 || _this.isSearch ? require('@/assets/img/logo.png') : require('@/assets/img/logo_w.png')
      };

    },
    showlangueBox(){
      
      this.isShowLangueBox =true
    },
    outsideClose() {
        this.isShowLangueBox = false
      }
  },
  mounted () {
    this.fixedTopinit()
    this.list = this.states.map((item) => {
      return { value: `value:${item}`, label: `label:${item}` };
    });

    // document.addEventListener('click', (e)=> {
    //   debugger
    //     if (e.target.className != 'language-select') {
    //         this.isShowLangueBox= false;
    //     }
    // })
  },
  watch: {
    selectvalue (data) {
      // this.$i18n.locale = data === 'CN' ? 'zn' : 'en'
      // localStorage.setItem('lang', data)
      // window.location.reload()
    },
    $route: {
      handler (to, from) {
        this.isSearch = to.name === 'search'
        this.logoimg = to.name === 'search' ? require('@/assets/img/logo.png') : require('@/assets/img/logo_w.png')

        this.navIndex = sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0

        window.scrollTo(0, 0)

        var scrollT = document.documentElement.scrollTop;
        this.fixedTop = scrollT > 75
        this.logoimg = scrollT > 75 || this.isSearch ? require('@/assets/img/logo.png') : require('@/assets/img/logo_w.png')
      },
      immediate: true,//第一次就执行
    }
  },
  directives: {
      clickoutside: {
        bind(el, binding, vnode) {
          function documentHandler(e) {
            if (el.contains(e.target)) {
              return false
            }
            if (binding.expression) {
              binding.value(e)
            }
          }

          function KeyUp(e) {
            if (e.keyCode == 27) {
              if (binding.expression) {
                binding.value(e)
              }
            }
          }
          el.__vueClickOutSize__ = documentHandler
          el.__vueKeyup__ = KeyUp
          
          document.addEventListener('keyup', KeyUp)
          document.addEventListener('click', documentHandler)
        },
        unbind(el, binding) {
          document.removeEventListener('click', el.__vueClickOutSize__)
          delete  el.__vueClickOutSize__

          document.removeEventListener('keyup', el.__vueKeyup__)
          delete  el.__vueKeyup__
        }
      }
    }
};
</script>
<style scoped lang="less">
#header.fixed-top {
  position: fixed;
  background: #fff;
  color: #000000;

  a {
    color: #000000 !important
  }

  a:hover {
    color: #2DB3D0 !important
  }

  .active>a {
    color: #2DB3D0 !important;
  }

  .underline {
    background-color: #2DB3D0 !important;
  }

  .header-nav .header-nav-wrapper>li.active>a {
    border-bottom: 2px solid #2DB3D0;
  }
}

/* 顶部 */
#header {
  transition: all ease 0.6s;
  position: absolute;
  z-index: 99;
  color: #fff;
  width: 100%;
  box-shadow: 0px 0px 0px 0.5px rgba(255, 255, 255, 0.3);
  /* border-bottom: 0.5px solid rgba(255, 255, 255, 0.3); */
  padding-top: 10px;
  margin: 0 auto;
  left: 0;
  right: 0
}

#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  display: flex;
  margin: 0 auto;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  // height: 100%;
  float: left;
  position: relative;
  margin: 0 115px 0 60px;
  overflow: hidden;
  cursor: pointer;
}
#header .header-nav .header-nav-logo.en{
  margin: 0 100px 0 60px;
}

#header .header-nav .header-nav-logo img {
  width: 162px;
  height: 60px;
}

#header .header-nav .header-nav-logo:hover img {
  transform: translateY(-60px);
  filter: drop-shadow(#2db3d0 0 60px);
  //颜色、x轴偏移量、y轴偏移量
}

/* 导航栏logo图片 */
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 64px;
  float: right;
  margin: 0;
  // max-width: 800px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper>li {
  float: left;
  margin: 0 15px;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper>li>a {
  color: #fff;
  font-size: 18px;
  padding: 32px 0 21px 0;
  position: relative;
}
#header .header-nav.en .header-nav-wrapper>li>a{
  font-size: 13px;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #fff;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>a>span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover {
  text-decoration: none;
  color: #fff;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
  background-color: #fff;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper>li.active>a {
  color: #fff;
  text-decoration: none;
  border-bottom: 2px solid #fff;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper>li>dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper>li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  background: #ccc;
}

.language-select {
  position: relative;
  display: inline-block;
  line-height: 54px;
  margin-left: 130px;
  cursor: pointer;
  // &:hover .languageSelect-box{
  //   display:block;
  // }
  width: 50px;
}
.languageSelected{
  line-height: 54px;
  line-height: 61px;
  display: flex;
  align-items: center;
  
  &>img{
    width: 16px;
    height: 16px;
    object-fit: contain;
    display: block;
  }
}
.fixed-top {
  .languageSelected{
    color: #8D8D8D;
  }
}
.languageSelect-box{
  position: absolute;
  right: 0;
  top: 50px;
  background: #fff;
  padding: 10px;
  width: 95px;
height: 64px;
box-shadow: 0px 2px 16px 0px rgba(8, 34, 64, 0.2);
border-radius: 4px;
display: none;
}
.languageSelect-item{
  font-size: 12px;
  color: #000000;
  line-height: 17px;
  margin-bottom: 10px;
  cursor: pointer;
  text-decoration: none;
  display: block;
  &:last-child{
    margin-bottom: 0px;
  }
  &.active{
    color: #2DB3D0;
  }
  // &:hover{
  //   color: #2DB3D0;
  // }
}
.language-select select {
  padding: 5px;
  background: none;
  border: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: none;
  border: none;
  background-color: transparent;
  background-image: url("../assets/img/down_white.png");
  background-repeat: no-repeat;
  background-position-x: calc(100% - 1em);
  background-position-y: 50%;
  padding-right: 1.5em;
  font-size: 15px;
}

#header.fixed-top .language-select select {
  background-image: url("../assets/img/down.png");
  
}

.language-select select::after {
  content: '';
  width: 0;
  height: 0;
  border-left: 0.4em solid transparent;
  border-right: 0.4em solid transparent;
  border-top: 0.4em solid #000000;
  position: absolute;
  right: 0.5em;
  top: calc(50% - 0.2em);
  pointer-events: none;
}

.language-select.EN select {
  padding-right: 34px;
}

.search {
  height: 100%;
  position: relative;
  top: 24px;
  cursor: pointer;
}

.longstring {
  margin: 0 26px;
  opacity: 0.3;
  height: 20px;
  display: block;
  background: #fff;
  width: 1px;
  top: 20px;
  position: relative;
  &.active{
    background: #ada2a2;
  }
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 10px;
  }
 
}</style>



// WEBPACK FOOTER //
// src/components/Header.vue